import styled from "styled-components";
import {FormContainer, FormRowContainer, MainContainer} from "../../../../common/generic-react.styles.js";
import {TitleContainer} from "../../../../components/atoms/title/title.styles.js";
export const WhiteLabelMainContainer = styled(MainContainer).withConfig({
  displayName: "white-label-detailstyles__WhiteLabelMainContainer",
  componentId: "sc-1qq5t50-0"
})(["max-width:820px;", " ", "{", "}"], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))"
}, TitleContainer, {
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  paddingTop: "2rem",
  paddingBottom: "2rem"
});
export const WhiteLabelDetailFormContainer = styled(FormContainer).withConfig({
  displayName: "white-label-detailstyles__WhiteLabelDetailFormContainer",
  componentId: "sc-1qq5t50-1"
})(["", ".default-account-permissions{", "}"], FormRowContainer, {
  marginTop: "2rem"
});
